import { rootApi } from "../../api/rootApi";

export const wheelCampaignApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    addWheelCampaign: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/wheelCampaign/add`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.data,
        };
      },
    }),
    getAllWheelCampaign: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/wheelCampaign`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    getWheelCampaignList: builder.mutation({
      query: (params) => {
        const searchParams = new URLSearchParams();
        if (params.page != null) searchParams.set("page", params.page);
        if (params.limit != null) searchParams.set("limit", params.limit);
        if (params.status) searchParams.set("status", params.status);
        if (params.search) searchParams.set("search", params.search);
        const query = searchParams.toString();
        return {
          method: "GET",
          url: `/tenant/wheelCampaign${query ? `?${query}` : ""}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    getWheelCampaignById: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/wheelCampaign/${params.id}`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    updateWheelCampaignById: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/wheelCampaign/${params.id}`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.data,
        };
      },
    }),
    deleteWheelCampaign: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/tenant/wheelCampaign/${params.id}`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
  }),
});

export const {
  useAddWheelCampaignMutation,
  useGetAllWheelCampaignMutation,
  useGetWheelCampaignListMutation,
  useGetWheelCampaignByIdMutation,
  useUpdateWheelCampaignByIdMutation,
  useDeleteWheelCampaignMutation,
} = wheelCampaignApi;